import { Icon } from '@iconify/react';
import { useRef, useState, useCallback, useEffect } from 'react';
import peopleFill from '@iconify/icons-eva/people-fill';
// material
import { alpha } from '@material-ui/core/styles';
import { ListItemAvatar, Typography, ListItemText, Avatar, ListItemButton, IconButton, TextField, Stack, Divider, Box } from '@material-ui/core';
// hooks
import useIsMountedRef from '../../hooks/useIsMountedRef';
// utils
import axios from '../../helper/axiosIntance';
import { fToNow } from '../../utils/formatTime';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import BadgeStatus from '../../components/BadgeStatus';
import { MIconButton } from '../../components/@material-extend';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from '../../redux/store';
import apiContact from '../../api/contact';
import FormActionContact2 from '../../pages/ActionContact/FormActionContact2';
// ----------------------------------------------------------------------

const ITEM_HEIGHT = 64;
const PADDING_ITEM = 2.5;
const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2),
        backgroundColor: '#f2f2f2',
        borderRadius: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(3),
    },
    input: {
        fontSize: '3em',
        textAlign: 'center',
    },
    button: {
        borderRadius: '50% !important',
        width: '30px !important',
        height: '60px !important',
        padding: '10px !important',
        fontSize: '1.5em !important',
        fontWeight: 'bold !important',
        border: '1px solid var(--neutral-10, #F4F4F4) !important',
        color: '#5F5F5F !important'
    },
    callButton: {
        borderRadius: '80px !important',
        backgroundColor: '#2ecc71 !important',
        color: '#fff !important'
    },
    backSpaceButton: {
        borderRadius: '80px !important',
        backgroundColor: '#EF4137 !important',
        color: '#fff !important'
    },
}));
export default function DialPadNum({ checkSip }) {
    const classes = useStyles();
    const [inputValue, setInputValue] = useState('');
    const [inputValueChange, setInputValueChange] = useState('');
    const dispatch = useDispatch();
    const { doCall } = useSelector(state => state.janus);
    const anchorRef = useRef(null);
    const isMountedRef = useIsMountedRef();
    const [open, setOpen] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [contactsFiltered, setContactsFiltered] = useState([]);
    const [isRefreshContact, setIsRefreshContact] = useState(false);
    const [phoneNumberSelect, setPhoneNumberSelect] = useState('');
    const [isShowAddContactOnSelect, setIsShowAddContactOnSelect] = useState(false);
    const handleAddContact = (phoneNumber) => {
        setPhoneNumberSelect(phoneNumber);
        setIsShowAddContactOnSelect(prev => !prev);
        handleClose();
    };
    const handleCloseAddContact = () => {
        setIsShowAddContactOnSelect(false);
    };
    const REGEX = {
        phone: /(0[2|3|5|7|8|9][0-9]{8})\b|(1[89]00[0-9]{4})\b|^[0-9]{3,}$/g,
        dial: /^-?[0-9#*]*$/,
      };
    useEffect(() => {
        if (inputValue !== "") {
            const filteredArray = contacts.filter(item => item?.phone?.includes(inputValue));
            setContactsFiltered(filteredArray);
        } else { setContactsFiltered([]); }
    }, [inputValue]);
    const handlePasteNumber = (phone) => {
        setInputValue(phone);
    }
    const handleDigitPress = (digit) => {
        // onDigitPress(digit);
        setInputValue((prevValue) => prevValue + String(digit));
    };
    const handleBackspacePress = () => {
        setInputValue((prevValue) => prevValue.slice(0, -1));
        // onBackspacePress();
    };
    const handleOpen = () => {
        if (checkSip == 1) {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };
    const callAndClear = async () => {
        const res_info = await apiContact.view({ phoneNumber: inputValue });
        doCall(inputValue, res_info.data.data);
    }
    const handleCallPress = () => {
        setOpen(false);
        callAndClear();
        setInputValue('');
    };


    const getContacts = useCallback(async () => {
        try {
            const res = await apiContact.view();
            setContacts(res.data.data);
        } catch (error) {
            console.error(error);
        }
    }, [isMountedRef]);

    useEffect(() => {
        getContacts();
    }, [getContacts]);

    const handleKeyDown = (e) => {
        // var arr = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "*", "#"];
        // if (arr.indexOf(e.key) > -1) {
        //     setInputValue((prevValue) => prevValue + String(e.key));
        // } else 
        if (e.key == "Backspace") {
            setInputValue((prevValue) => prevValue.slice(0, -1));
        } else if (e.key == "Enter") {
            handleCallPress();
        }
    };

    const handleChangeInput = (e) => {
        const phoneText = e.target.value;
        if (phoneText.match(REGEX.dial)) {
            setInputValue(phoneText);
        }
      };

    return (
        <>
            <MIconButton
                ref={anchorRef}
                size="large"
                color={open ? 'primary' : checkSip == 1 ? 'success' : 'default'}
                onClick={handleOpen}
                sx={{
                    ...(open && {
                        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
                    })
                }}
            >
                <Icon icon="ion:call" width={20} height={20} />
            </MIconButton>

            <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: '344px', height: '630px' }}>
                {/* <TextField
                    type="text"
                    sx={{ border: 'none', "& fieldset": { border: 'none' } }}
                    defaultValue={inputValue}
                    value={inputValue}
                    fullWidth
                    variant="outlined"
                    autoFocus
                    inputProps={{ min: 0, style: { textAlign: 'center' } }}
                    InputProps={{
                        component: Typography,
                        variant: 'h1 !important',
                        sx: {
                            // border: '1px solid black',
                            // borderRadius: '10px',
                            fontSize: '32px',
                            fontWeight: 'bold !important'
                        }
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onKeyDown={(e) => handleKeyDown(e)}
                /> */}
                <TextField
                    autoFocus
                    value={inputValue}
                    onChange={handleChangeInput}
                    sx={{
                        width: '100%',
                        backgroundColor: 'white',
                        '& fieldset': { border: 'none' },
                        fontSize: 20,
                        '& input': {
                            fontSize: 22,
                            background: 'transparent',
                            textAlign: 'center',
                            letterSpacing: '1px',
                            padding: '16px 14px 10px 14px',
                            fontWeight: 'bold',
                        },
                    }}
                    onKeyDown={(e) => handleKeyDown(e)}
                />
                <Divider />
                <Stack sx={{ height: '25%' }}>
                    {inputValue !== "" && contactsFiltered.length == 0 ? <Button onClick={() => handleAddContact(inputValue)} startIcon={<Icon icon="mingcute:user-add-line" />}>Thêm danh bạ</Button> : <Scrollbar sx={{ height: ITEM_HEIGHT * 4 }}>
                        <Stack spacing={1} sx={{ p: 1 }}>
                            {contactsFiltered && contactsFiltered.map((contact) => {
                                const { id, name, avatar, status, phone } = contact;
                                return (
                                    <Stack direction="row" alignItems="center" sx={{ cursor: 'pointer' }} key={id} onClick={() => handlePasteNumber(phone)}>
                                        <Avatar src={avatar} sx={{ width: 36, height: 36 }} />
                                        <Box sx={{ flexGrow: 1, ml: 2, minWidth: 100 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                                                {phone}
                                            </Typography>
                                            <Typography variant="subtitle2" noWrap>
                                                {name}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                );
                            })}
                        </Stack>
                    </Scrollbar>}
                </Stack>
                <Stack spacing={2} sx={{ mt: 2 }}>
                    <Stack direction={'row'} spacing={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('1')}
                        >
                            1
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('2')}
                        >
                            2
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('3')}
                        >
                            3
                        </Button>
                    </Stack>
                    <Stack direction={'row'} spacing={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('4')}
                        >
                            4
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('5')}
                        >
                            5
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('6')}
                        >
                            6
                        </Button>
                    </Stack>
                    <Stack direction={'row'} spacing={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('7')}
                        >
                            7
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('8')}
                        >
                            8
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('9')}
                        >
                            9
                        </Button>
                    </Stack>
                    <Stack direction={'row'} spacing={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('*')}
                        >
                            *
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('0')}
                        >
                            0
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={() => handleDigitPress('#')}
                        >
                            #
                        </Button>
                    </Stack>
                    <Stack direction={'row'} spacing={1} sx={{ display: 'flex', justifyContent: 'center', pl: '42px', pr: '36px', pt: '10px' }}>
                        <Button
                            onClick={() => handleCallPress()}
                            className={classes.callButton}
                            sx={{ width: '60%' }}
                        >
                            <Icon icon="ion:call" color='white' height={"24px"} width={"24px"} />
                        </Button>
                        <Button
                            onClick={() => handleBackspacePress()}
                            className={classes.backSpaceButton}
                            sx={{ width: '40%' }}
                        >
                            <Icon icon="material-symbols:backspace-outline" height={"24px"} width={"24px"} />
                        </Button>
                    </Stack>
                </Stack>
            </MenuPopover>
            {isShowAddContactOnSelect && <FormActionContact2
                infoContact={[]}
                type={'quick_callhistory'}
                participants={[]}
                phoneNumberSelect={phoneNumberSelect}
                setIsRefreshContact={setIsRefreshContact}
                isOpen={isShowAddContactOnSelect}
                onClose={handleCloseAddContact}
                onDeleteTask={() => { }}
            />
            }
        </>
    );
}
